import { number, object, string } from "yup";

export const newCategorySchema = object({
  title: string().required("Title is required"),
  position: number(),
});
